module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_tablet_01@2x-b951a0409447de6632a4fa3039d76010.jpg";